import React from 'react'
import classnames from 'classnames'
import './index.scss'

export default ({ label, className, error, ...props }) => (
  <div className={classnames('material-input', className)}>
    <input placeholder={label} {...props} />
    <label>{label}</label>
    {error && <span>{error}</span>}
  </div>
)